<template>
  <div class="h-screen min-h-full md:flex">
    <div class="relative h-full overflow-y-auto">
      <div class="w-full bg-white-500 p-6 md:absolute">
        <img src="/pictures/logo.svg" alt="Teachino Logo" class="h-6" />
      </div>
      <div
        class="flex h-full min-h-160 flex-1 flex-col px-4 py-12 sm:px-6 md:justify-center md:px-20 lg:flex-none xl:px-24"
      >
        <div class="mx-auto w-full max-w-sm lg:w-96">
          <div>
            <h1 class="text-[2rem] font-normal text-neutral-950">
              {{ pageTitle }}
            </h1>
            <p class="mt-4 text-neutral-950">
              {{ props.error }}
            </p>
          </div>


          <div class="text-neutral-500 mt-4">
          Wenn es Probleme mit unseren Servern gibt, findest Du den aktuellen Status auf unserer Status-Seite. Dort halten wir Dich auch über laufende Wartungsarbeiten und Störungen auf dem Laufenden.

               <a href="https://status.teachino.io/" target="_blank" class="text-primary-500 underline">
                Status-Seite öffnen
              </a>
          </div>


          <TButtonInline class="mt-8" :action="redirectToHome">
            {{ $t('error_page.button') }}
          </TButtonInline>

          <TButtonInlineSecondary class="mt-8" :action="logOut">
            {{ $t('navigation.log_out') }}
          </TButtonInlineSecondary>
        </div>
      </div>
    </div>
    <div
      class="hidden flex-1 flex-col justify-end bg-cover bg-center px-4 py-12 sm:px-6 md:flex lg:px-20 xl:px-24"
      :style="{
        backgroundImage: 'url(\'' + pictureUrls.error + '\')',
      }"
    />
  </div>
</template>
<script lang="ts" setup>
import { pictureUrls } from '~/utils/constants';

const { $t } = useNuxtApp();

const props = defineProps<{ error: { statusCode: number } }>();

const pageTitle = ref(
  props.error.statusCode === 404
    ? $t('error_page.title_404')
    : $t('error_page.title'),
);
useHead({
  title: pageTitle.value,
});

function redirectToHome() {
  navigateTo('/');
}

function logOut() {
  navigateTo('auth/logout');
}

function openStatusPage() {
  window.open('https://status.teachino.io', '_blank');
}

</script>
